module.exports = __webpack_public_path__ + "static/testing-f7e723be9ada231af1aa9eee401e0629.svg";